// removed by extract-text-webpack-plugin
module.exports = {"loadingList":"LoadingComponent__loadingList--1nQeF"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/LoadingComponent.css
// module id = FDl4
// module chunks = 47